import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { telechargerFichier } from '../../../App_Code/API';
import { mapStateToPropsWrapper, verificationProps } from '../../CaptureErreurs';
import Card, { LigneCard } from '../../Card';
//import les 7 notices différentes celon les parmatètres prélèvements de l'agence
import NoticePrelevement_Manuel from '../../../PDF/NoticePrelevement_Manuel.pdf';
import NoticePrelevement_Exigi from '../../../PDF/NoticePrelevement_Exigi.pdf';
import NoticePrelevement_Mensuel from '../../../PDF/NoticePrelevement_Mensuel.pdf';
import NoticePrelevement_Exigi_Manuel from '../../../PDF/NoticePrelevement_Exigi_Manuel.pdf';
import NoticePrelevement_Mensuel_Exigi from '../../../PDF/NoticePrelevement_Mensuel_Exigi.pdf';
import NoticePrelevement_Menusel_Manuel from '../../../PDF/NoticePrelevement_Mensuel_Manuel.pdf';
import NoticePrelevement from '../../../PDF/NoticePrelevement.pdf';


const PrelevementInactif = ({ ALaDemande, AutoMensuel, AutoExigibilite }) => {
    //choisi la notice celon les paramètres agence.
    let notice = ALaDemande & AutoMensuel & AutoExigibilite ?  NoticePrelevement 
                : AutoMensuel & AutoExigibilite  ? NoticePrelevement_Mensuel_Exigi
                : AutoMensuel & ALaDemande ? NoticePrelevement_Menusel_Manuel 
                : AutoExigibilite & ALaDemande ? NoticePrelevement_Exigi_Manuel 
                : AutoMensuel ? NoticePrelevement_Mensuel 
                : AutoExigibilite ? NoticePrelevement_Exigi 
                : ALaDemande ? NoticePrelevement_Manuel : null ;
    return (
        <React.Fragment>
            <p className="card-text mb-0">
                Ce service <b>gratuit</b> et <b>sécurisé</b> vous permet de choisir votre formule de règlement de vos appels de fonds :
                <b hidden={!(AutoMensuel || AutoExigibilite)}> automatiquement </b>
                <span hidden={!(ALaDemande && (AutoMensuel || AutoExigibilite))} >ou</span>
                <b hidden={!ALaDemande}> à la demande </b>.
            </p>
            <div className="d-flex flex-wrap">
                <Link to={{ pathname: '/MesInformations/Document', state: { URI: notice } }} className="btn btn-info mt-3 mr-3" hidden={notice===null}>
                    Voir la notice
                </Link>
                <Link to={{ pathname: '/MesInformations/SaisieRIB', state: { TypePrelevement: 'Automatique' } }} className="btn btn-primary mt-3 mr-3" hidden={!(AutoMensuel || AutoExigibilite)}>
                        Automatiquement
                </Link>
                <Link to={{ pathname: '/MesInformations/SaisieRIB', state: { TypePrelevement: 'Manuelle' } }} className="btn btn-primary mt-3 mr-3" hidden={!ALaDemande} >
                    A la demande
                </Link>
            </div>
        </React.Fragment>
    );
}

const ModePrelevement = (ModePrl) => {
    switch (ModePrl) {
    case 1:
        return "Automatique à l'exigibilité";
    case 2:
        return 'Automatique mensualisé';
    case 3:
        return 'Manuel à la demande';
    default:
        return 'Non défini';
    }
};

const PrelevementActif = ({
    Iban, Bic, Rum, IdMandatActif, ModePrl, ProcedureEnCours, PageGererPrelevement, PagePaiement, NomSurRIB,
}) => (
    <React.Fragment>
        <div className="card-text mb-0">
            <LigneCard titre="État du service" valeur="Actif" iconePre="text-success fas fa-check" />
            <LigneCard titre="Mode" valeur={ModePrelevement(ModePrl)} />
            <LigneCard titre="IBAN" valeur={Iban} classeValeur="font-weight-bold" />
            <LigneCard titre="BIC" valeur={Bic} />
            <LigneCard titre="Titulaire" valeur={NomSurRIB} />
            <LigneCard titre="RUM" valeur={`n° ${Rum}`} derniereLigne />
        </div>
        <div className="d-flex justify-content-around" >
            <Link to="/MesInformations/GererPrelevement" className="btn btn-outline-primary mt-3 w-50" hidden={PageGererPrelevement || PagePaiement}>
                Gérer
            </Link>
            { IdMandatActif ? (
                <a target="_blank" href={telechargerFichier(IdMandatActif)} className="btn btn-outline-primary mt-3 mr-3 w-50" hidden={!PageGererPrelevement}>
            Voir mon mandat
                </a>
            ) : (
                <div className="btn btn-secondary disabled mt-3 mr-3" hidden={!PageGererPrelevement}>
            Mandat indisponible
                </div>
            )}
            <Link to={{ pathname: '/MesInformations/SaisieRIB', state: { TypePrelevement: ModePrl === 3 ? 'Manuelle' : 'Automatique' } }} className="btn btn-outline-orange mt-3 w-50" hidden={!PageGererPrelevement || ProcedureEnCours}>
                Nouveau mandat
            </Link>
        </div>
        <div className="mt-2 col-12" style={{color: '#f57c00'}} hidden={!PageGererPrelevement || ProcedureEnCours}>
            <i className="fas fa-info-circle" />
            <span className="ml-2">Faire un "Nouveau Mandat" lors d'un changement de banque et/ou d'IBAN/BIC.</span>
        </div>   
    </React.Fragment>
);

const CardPrelevement = ({
    Rib, Mandat, ModePrl, Accueil, PageGererPrelevement, PagePaiement, Cop,
}) => {
    let className = '';
    let composant = null;

    /* Si le service est actif, on n'affiche pas cette Card sur l'accueil */
    if (Accueil && (!Cop.PrlOk || Mandat.PrlOk)) return null;

    if (!Cop.PrlOk) return null;

    if (!Mandat.PrlOk) {
        className = 'alert-primary';
        composant = <PrelevementInactif {...ModePrl} />;
    } else if (PageGererPrelevement) {
        composant = <PrelevementActif {...Rib} {...Mandat} PageGererPrelevement />;
    } else if (PagePaiement) {
        composant = <PrelevementActif {...Rib} {...Mandat} PagePaiement />;
    } else { composant = <PrelevementActif {...Rib} {...Mandat} />; }

    return (
        <Card Titre={!Mandat.PrlOk ? 'Mon prélèvement' : 'Mon mandat'} className={className}>
            {composant}
        </Card>
    );
};
CardPrelevement.displayName = 'CardPrelevement';
CardPrelevement.titleName = 'Mon prélèvement';
CardPrelevement.requiredProps = [
    'Mandat', // Mandat SEPA
    'ModePrl', // Mode prélèvement du syndic
];

function mapStateToProps({
    ProStore: {
        Pro: { Rib, Mandat },
    },
    SynStore: {
        Syn: { ModePrl },
    },
    CopStore: {
        Cop,
    },
}) {
    return {
        Rib, Mandat, ModePrl, Cop,
    };
}

export default connect(mapStateToPropsWrapper(mapStateToProps))(verificationProps(CardPrelevement));



// WEBPACK FOOTER //
// ./src/components/MesInfos/Prelevement/CardPrelevement.js